import { MessageInterface } from "./Interface";

export enum SubscriptionTypes  {
    CREATE_SUBSCRIPTION='CREATE_SUBSCRIPTION',
	CANCEL_SUBSCRIPTION='CANCEL/SUBSCRIPTION',
	CHANGE_STATUS='CHANGE/STATUS',
    Errors = 'Subscription/Errors'
}

interface createSubscription {
    type: typeof SubscriptionTypes.CREATE_SUBSCRIPTION
}
interface cancelSubscription {
    type: typeof SubscriptionTypes.CANCEL_SUBSCRIPTION,
	payload:{
		message:any;
	}
}
interface statusChange{
	type: typeof SubscriptionTypes.CHANGE_STATUS
}
interface Errors {
	type: typeof SubscriptionTypes.Errors;
	payload: {
		errors: any;
	};
}


export type SUbscriptionTypeAction = createSubscription | cancelSubscription| statusChange | Errors
